<template>
  <div class="heading-title-rounded-btn">
    <slot name="svg" />
  </div>
</template>

<style lang="scss" scoped>
.heading-title-rounded-btn {
  width: 75px;
  height: 75px;
  text-align: center;
  border-radius: 75px;
  border: 0;
  box-shadow: 5px 5px 15px #c46d08;
  background-color: $gkt-orange;
  line-height: 75px;
  position: relative;
  margin-right: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  ::deep(svg) {
    position: relative;
    left: 7px;
  }

  svg {
    position: relative;
    left: 7px;
  }

  &::before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 38px;
    box-shadow: -5px -5px 15px rgba(245, 154, 63, 0.87);
  }
}
</style>
